import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ViewListIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "view-list",
  "ViewListIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M2.6665 12.6666H13.3332V11.3333H2.6665V12.6666ZM2.6665 8.66663H13.3332V7.33329H2.6665V8.66663ZM2.6665 4.66663H13.3332V3.33329H2.6665V4.66663Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default ViewListIcon;
